<template>
  <div>
    <div class="wrapper wrapper_mob vouchers-page">
      <div class="container-fluid px-0">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="vouchers-filter-grid">
              <div>
                <label>Filter</label>
                <b-dropdown
                  class="custom-dropdown-1 form-control"
                  text="All"
                  variant="default"
                  slot="append"
                >
                  <b-dropdown-item>All</b-dropdown-item>
                </b-dropdown>
              </div>
              <div>
                <label>Date Range</label>
                <div class="date-range-flex">
                  <div>
                    <input type="date" class="form-control" />
                  </div>
                  <div>
                    <input type="date" class="form-control" />
                  </div>
                </div>
              </div>
              <div>
                <button class="btn btn-pink">Apply</button>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-shadow d-none">
          <h1 class="text-center">E-Vouchers</h1>
          <div class="row row-flex">
            <div class="col-lg-4">
              <div>
                <label>Discount Type</label>
                <multiselect
                  :options="options"
                  v-model="value"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :select-label="''"
                  :deselect-label="''"
                  :selectedLabel="''"
                  class="custom-multiselect no-scroll"
                >
                </multiselect>
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label>Voucher Code</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Voucher Code"
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label>Cinema Specific</label>
                <multiselect
                  :options="options"
                  multiple="true"
                  v-model="value"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :select-label="''"
                  :deselect-label="''"
                  :selectedLabel="''"
                  class="custom-multiselect no-scroll"
                >
                </multiselect>
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label>Movie Specific</label>
                <multiselect
                  :options="options"
                  multiple="true"
                  v-model="value"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :select-label="''"
                  :deselect-label="''"
                  :selectedLabel="''"
                  class="custom-multiselect no-scroll"
                >
                </multiselect>
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label>Voucher Limit</label>
                <input
                  type="mumber"
                  class="form-control"
                  placeholder="Voucher Code"
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label>Voucher Expiry</label>
                <input
                  type="date"
                  class="form-control"
                  placeholder="Voucher Code"
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label>Transaction Type</label>
                <multiselect
                  :options="options"
                  v-model="value"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :select-label="''"
                  :deselect-label="''"
                  :selectedLabel="''"
                  class="custom-multiselect no-scroll"
                >
                </multiselect>
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label>No. of uses per customer</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Voucher Code"
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label>Day of the week specific</label>
                <multiselect
                  :options="options"
                  v-model="value"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :select-label="''"
                  :deselect-label="''"
                  :selectedLabel="''"
                  class="custom-multiselect no-scroll"
                >
                </multiselect>
              </div>
            </div>
            <div class="col-lg-4">
              <b-form-checkbox v-model="checked" name="check-button" switch>
                Voucher Active
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-lg-12" style="min-height:60vh;">
            <h1 class="text-center">NO COUPONS FOUND</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: null,
      options: [
        "Select option",
        "options",
        "selected",
        "multiple",
        "label",
        "searchable",
        "clearOnSelect",
        "hideSelected",
        "maxHeight",
        "allowEmpty",
        "showLabels",
        "onChange",
        "touched"
      ]
    };
  }
};
</script>

<style scoped>
.vouchers-filter-grid {
  display: grid;
  grid-template-columns: 20% 50% 20%;
  align-items: end;
  gap: 30px;
}
.date-range-flex input::after {
  background: none !important;
  border: 1px solid transparent !important;
}
.vouchers-filter-grid .form-control {
  box-shadow: none;
  border-radius: 05px;
  border: 1px solid #ddd;
  width: 100%;
}
.date-range-flex {
  display: flex;
  gap: 30px;
}
.btn-pink {
  background: var(--pink);
  color: #ffff;
  padding: 10px 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/userVouchers.vue